import { render } from "./DynamicImage.vue?vue&type=template&id=f3edab98&ts=true"
import script from "./DynamicImage.vue?vue&type=script&lang=ts"
export * from "./DynamicImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3edab98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3edab98', __exports__)) {
    api.reload('f3edab98', __exports__)
  }
  
  module.hot.accept("./DynamicImage.vue?vue&type=template&id=f3edab98&ts=true", () => {
    api.rerender('f3edab98', render)
  })

}


export default __exports__